module.exports = "/assets/ef5fb00a4ab5396b8370299caaba95a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WK.png
// module id = 1963
// module chunks = 0